import { PageType as DefaultPageType } from '../Page';

export import PageType = DefaultPageType;